import CheckboxGroup from "./v-checkbox-group.vue";
import Checkbox from "./v-checkbox.vue";

/* istanbul ignore next */
Checkbox.install = function(Vue) {
  Vue.component(Checkbox.name, Checkbox);
  Vue.component(CheckboxGroup.name, CheckboxGroup);
};

export { Checkbox, CheckboxGroup };
